import React from "react";
import _values from "lodash/values";
import { DropdownCheckbox } from "../../../../../Molecules/DropdownCheckbox/DropdownCheckbox";
import {
  CheckboxGroup,
  ICheckboxGroupValue,
} from "../../../../CheckboxGroup/CheckboxGroup";
import { IDropdownCheckboxValueItemConfig } from "../../../../../Molecules/DropdownCheckbox/DropdownCheckboxValue";
import { IFilterValues, IGetFilterFieldConfig } from "../../../types";
import { getCheckboxTags } from "../../../helpers/getCheckboxTags";
import { TFunction } from "i18n";

export interface CheckboxGroupProps
  extends Pick<
    IGetFilterFieldConfig<IFilterValues>,
    | "name"
    | "values"
    | "filterDrawerValues"
    | "setFilterValues"
    | "setFilterDrawerValues"
    | "dataTestId"
  > {
  filterTitle?: string;
  fieldOptions: IDropdownCheckboxValueItemConfig[];
  fieldOptionsWithStats?: IDropdownCheckboxValueItemConfig[];
  t: TFunction;
}

export function getCheckboxGroupComponents({
  name,
  filterTitle,
  fieldOptions,
  fieldOptionsWithStats,
  values,
  filterDrawerValues,
  setFilterValues,
  setFilterDrawerValues,
  dataTestId,
  t,
}: CheckboxGroupProps) {
  const fieldValue = values[name] as ICheckboxGroupValue;
  const filterDrawerValue = filterDrawerValues[name];
  const title = filterTitle || t(`common:search.filters.title.${name}`);
  const checkboxConfig = {
    name,
    options: fieldOptionsWithStats || fieldOptions,
  };

  const filterControlComponent = (
    <DropdownCheckbox
      ValueComponent={DropdownCheckbox.getDefaultValueComponent({
        selectionPlaceholder: title,
        selectionPrefix: "",
      })}
      checkboxGroupConfig={checkboxConfig}
      value={values[name] as ICheckboxGroupValue}
      valueChanged={(value) => {
        setFilterValues({
          [name]: value,
        });
      }}
      key={name}
      data-testid={dataTestId}
    />
  );

  const filterDrawerConfig = {
    title,
    id: name,
    selected: _values(filterDrawerValue).some((v) => v),
    renderFilterContent: () => (
      <CheckboxGroup
        config={checkboxConfig}
        value={filterDrawerValue as ICheckboxGroupValue}
        valueChanged={(value) => {
          setFilterDrawerValues({
            [name]: value,
          });
        }}
      />
    ),
  };

  const tags = getCheckboxTags({
    name,
    fieldValue,
    fieldOptions,
    t,
    setFilterValues,
  });

  return {
    filterControlComponent,
    filterDrawerConfig,
    tags,
  };
}
